import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { SearchModal } from "@components/SearchModal";

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className="gu-page-shell flex min-h-[100vh] flex-col">
            <Header />
            <main className="grow pt-20">{children}</main>
            <Footer />

            <SearchModal />
        </div>
    );
};

export default Layout;
